jQuery(document).ready(function($) {
	// Handler for .ready() called.
	
	// Accordion Content
	$('.accordion .toggle').click(function(e) {
	  	e.preventDefault();
	  
	    var $this = $(this);
	  
	    if ($this.next().hasClass('show')) {
		    $this.removeClass('active');
	        $this.next().removeClass('show');
	        $this.next().slideUp(350);
	        //$this.find('.icon').toggleClass('fa-minus');
	        //$this.find('.icon').toggleClass('fa-plus');
	    } else {
		    $this.parent().parent().find('.toggle').removeClass('active');
	        $this.parent().parent().find('li .accordion-inner').removeClass('show');
	        //$this.parent().parent().find('.active .icon').toggleClass('fa-plus');
	        $this.parent().parent().find('li .accordion-inner').slideUp(350);
	        $this.next().toggleClass('show');
	        $this.toggleClass('active');
	        //$this.find('.icon').toggleClass('fa-minus');
	        $this.next().slideToggle(350);
	        //$this.find('.icon').removeClass('fa-plus');
	    }
	/*
	    if($this.hasClass('active')) {
		    $this.removeClass('active');
	    } else {
		    $this.addClass('active');
	    }
	*/
	});
  
});
